<script lang="ts">
  import {createEventDispatcher, onDestroy, onMount} from 'svelte';
  import {Video, VideoTimeStamp} from './Video';
  import {VideoControls} from '@/components';
  import {Timestamp} from '@/store/recap';

  const dispatch = createEventDispatcher();

  export let videoSrc = '';
  export let timestamps: VideoTimeStamp[] = [];

  let useOriginalVideo = false;
  let videoElement: HTMLVideoElement;
  let video: Video;
  let progress = 0;

  export let isBuffering = false;

  onMount(() => {
    video = new Video(videoElement, []);
    video.onTimeupdate(event => {
      dispatch('timeupdate', event);

      if (isBuffering) isBuffering = false;
      if (!progressBar) return;

      let bar = progressBar.getProgressElement();
      bar.value = (event.currentTime / duration) * 100;
      progress = bar.value;
      progressBar.changeRunnerColor(bar);
    });

    video.onBuffering(() => {
      // console.log("isBuffering");
      isBuffering = true;
    });
  });

  let progressBar: any;
  let duration = 0;

  function stopVideo() {
    if (useOriginalVideo) {
      videoElement.pause();
      videoElement.currentTime = 0;
      return;
    }
    video.stop();
  }

  function playVideo() {
    if (useOriginalVideo) {
      videoElement.paused ? videoElement.play() : videoElement.pause();
      return;
    }
    video.play();
  }

  function pauseVideo() {
    if (useOriginalVideo) {
      if (!videoElement.paused) videoElement.pause();
      return;
    }
    video.pause();
  }

  function seekTimeline(event: any) {
    if (useOriginalVideo) {
      videoElement.currentTime = videoElement.duration * (event.detail.value / 100);
      return;
    }
    video.seek(video.duration() * (event.detail.value / 100));
  }

  function switchBetweenVideos(value: boolean) {
    useOriginalVideo = value;
    duration = useOriginalVideo ? videoElement.duration : video.duration();
    progress = 0;
    isBuffering = false;
    stopVideo();
  }

  $: if (useOriginalVideo) {
    let bar = progressBar.getProgressElement();
    bar.value = (videoElement.currentTime / videoElement.duration) * 100;
    progress = videoElement.currentTime;
    progressBar.changeRunnerColor(bar);
    video.detatchVideo(); // skip over event listener
  } else {
    if (video) {
      progress = video.currentTime;
      duration = video.duration();
      video.attachVideo(); // resume event listener
    }
  }

  $: if (video) {
    console.log('timestamps', timestamps);
    video.setNewTimestamps(timestamps);
    duration = video.duration();
    // console.log("hellp from video", timestamps)
  }

  onDestroy(() => {
    video.destroy();
  });
</script>

<div class="flex h-full w-full flex-grow justify-center overflow-hidden">
  <div class="relative flex w-full flex-col items-center justify-center pb-16">
    <div class="w-full" style="max-width: 1800px">
      <div class="relative">
        <!-- preserve height -->
        <div class="px-4 py-2">&nbsp;</div>
        <div class="absolute bottom-0 left-0 h-full w-full border-b-2"></div>
        <div class="absolute left-0 top-0 flex h-full w-full">
          <button
            on:click={() => switchBetweenVideos(true)}
            class="px-4 py-2 {useOriginalVideo ? 'bottom-b-2 border-rose-500 text-rose-500' : ''}"
            >Original Video</button
          >
          <button
            on:click={() => switchBetweenVideos(false)}
            class="px-4 py-2 {useOriginalVideo ? '' : 'border-b-2 border-rose-500 text-rose-500'}"
            >Highlighted Moments</button
          >
        </div>
      </div>
      <div class="relative flex max-w-full px-8 py-4">
        <!-- svelte-ignore a11y-media-has-caption -->
        <video bind:this={videoElement} class="h-full w-full rounded-lg" controls={false} src={videoSrc}></video>
        {#if isBuffering}
          <div class="absolute left-0 top-0 h-full w-full px-5 py-2.5">
            <div style="background: rgba(0,0,0,0.5);" class="h-full w-full"></div>
          </div>
          <div class="absolute left-0 top-0 flex h-full w-full items-center justify-center">
            <img
              src="https://storage.googleapis.com/sermonshots-homepage/v2/images/sermonshot-loader.gif"
              alt="loader"
            />
          </div>
        {/if}
      </div>
    </div>
    <div class="absolute bottom-0 w-full">
      <VideoControls
        bind:progressBar
        bind:progress
        showDuration={true}
        on:stop-video={stopVideo}
        on:play-video={playVideo}
        on:pause-video={pauseVideo}
        on:seek-timeline={seekTimeline}
        bind:duration
      />
    </div>
  </div>
</div>
